export default __webpack_public_path__ + "static/media/8.c6d0cd16.png";